import React from 'react';
import { PrContainer, SectionPartition } from './styled';
import Awards from '../AwardsSection/Awards';
import FeaturedOnNew from '../FeaturedOnNew/FeaturedOnNew';

const PrSection = () => {
  return (
    <PrContainer>
      <Awards />
      <SectionPartition></SectionPartition>
      <FeaturedOnNew />
    </PrContainer>
  );
};

export default PrSection;
